import { Global } from "../Shared/Global";
import Player from "../Models/Player";
import UIManager from "../Shared/UIManager";
import NetworkLogic from "../Shared/NetworkLogic";
import GameList from "../Models/GameList";
import WebViewManager from "../Shared/WebViewManager";
import ThirdGamesListUI from "./ThirdGamesListUI";
import Constant from "../Shared/Constant";
import Utils from "../Shared/Utils";
import SDKManager from "../Shared/SDKManager";
import RemoteSprite from "../Common/RemoteSprite";
import AudioManager from "../Shared/AudioManager";
import PingTool from "../Shared/PingTool";
import YinShangAccount from "../Models/YinShangAccount";
import AddressManager from "../Shared/AddressManager";
import NoticeData from "../Models/NoticeData";
import SignIn from "./Sign/SignIn";
import SignData from "./Sign/SignData";
import ActivityData from "./Activity/ActivityData";
import TaskData from "./TaskLayer/TaskData";
import PopWindowManager from "../Shared/PopWindowManager";
import WechatNoticeData from "./WechatNotice/WechatNoticeData";
import TopElectronicUI from "./TopElectronicUI";
import EnterSoundManager from "../Shared/EnterSoundManager";
const i18n = require("LanguageData");

const { ccclass, property } = cc._decorator;

@ccclass
export default class HallUI extends cc.Component {
    @property(cc.Node)
    taskRedPoint: cc.Node = null

    @property(cc.Label)
    labTaskRedNum: cc.Label = null

    @property(cc.Node)
    goldPos: cc.Node = null

    @property(cc.Node)
    signBtn: cc.Node = null

    @property(cc.Label)
    signalNum: cc.Label = null

    @property([cc.SpriteFrame])
    signalIconArr: cc.SpriteFrame[] = []

    @property([cc.SpriteFrame])
    wifiIconArr: cc.SpriteFrame[] = []

    @property(cc.Sprite)
    signalSprite: cc.Sprite = null

    @property(cc.Node)
    nodeLoading: cc.Node = null

    @property(cc.Node)
    nodeMore: cc.Node = null

    @property(cc.Animation)
    aniHall: cc.Animation = null

    // @property(cc.Prefab)
    // pfbLoginQuickRegister: cc.Prefab = null;
    @property(cc.Prefab)
    pfbLoginCurrencyChoose: cc.Prefab = null;
    @property(cc.Prefab)
    pfbLoginCompleteInformation: cc.Prefab = null;

    @property(cc.Prefab)
    pfbBindWeChat: cc.Prefab = null

    @property(cc.Prefab)
    pfbRecommondActivity: cc.Prefab = null

    @property(cc.Prefab)
    pfbRecommondTask: cc.Prefab = null

    @property(cc.Prefab)
    baoxiangPrefab: cc.Prefab = null

    @property(cc.Prefab)
    pfbRegisterUI: cc.Prefab = null

    @property(cc.Prefab)
    pfbLoginUI: cc.Prefab = null

    @property(cc.Prefab)
    pfbPlayerCenter: cc.Prefab = null

    @property(cc.Prefab)
    pfbSettingLayer: cc.Prefab = null

    @property(cc.Prefab)
    pfbThirdGamesListUI: cc.Prefab = null

    @property(cc.Prefab)
    pfbWithdrawalUI: cc.Prefab = null

    @property(cc.Prefab)
    pfbRechargeUI: cc.Prefab = null

    @property(cc.Prefab)
    pfbCustomerServiceUI: cc.Prefab = null

    @property(cc.Prefab)
    pfbMsgBoxUI: cc.Prefab = null

    @property(cc.Prefab)
    pfbActivity: cc.Prefab = null;

    @property(cc.Prefab)
    pfbSignal: cc.Prefab = null;

    @property(cc.Prefab)
    pfbXima: cc.Prefab = null;

    @property(cc.Prefab)
    pfbVip: cc.Prefab = null;

    @property(cc.Prefab)
    pfbTuiGuang: cc.Prefab = null;

    @property(cc.Prefab)
    pfbTopElectronicLayer: cc.Prefab = null;

    @property(cc.Prefab)
    pfbSignInUI: cc.Prefab = null

    @property(cc.Prefab)
    pfbRankingListUI: cc.Prefab = null

    @property(cc.Prefab)
    pfbNoticeUI: cc.Prefab = null

    @property(cc.Prefab)
    pfbFixToolUI: cc.Prefab = null

    @property(cc.Widget)
    wgtGameTypes: cc.Widget = null

    @property(cc.Label)
    lbUserID: cc.Label = null

    @property(cc.Label)
    lbVip: cc.Label = null

    @property(cc.Label)
    lbUnReadMsg: cc.Label = null

    @property(cc.Node)
    nodeTimeReceive: cc.Node = null

    @property(cc.Label)
    lbNotice: cc.Label = null

    @property(cc.ProgressBar)
    barExp: cc.ProgressBar = null

    @property(cc.Node)
    nodePlayer: cc.Node = null

    @property(cc.Node)
    nodePlayerUnLogin: cc.Node = null

    @property(RemoteSprite)
    rspHead: RemoteSprite = null

    @property(cc.ScrollView)
    svGameTypes: cc.ScrollView = null

    @property(RemoteSprite)
    remoteLogo: RemoteSprite = null



    public _curChildUI: cc.Node = null
    public _thirdGamesListUI: ThirdGamesListUI = null
    private _interval: number = 5;
    private _versionData = null
    private _isPulledLoginConfig = false

    private _isGotTemplateId = false;
    private _bEnterHall = false;
    private _siteUrl = ""
    private _clickTestBtnTimes = 0
    public bAutoLogin = false;

    onLoad() {
        SDKManager.setBadge(0)
        this.nodePlayerUnLogin.active = true
        this.nodePlayer.active = false
        this.barExp.progress = 0
        this.lbUnReadMsg.node.parent.active = false
        this.nodeTimeReceive.active = false
        this.lbNotice.node.active = false
        this.nodeLoading.active = true
        this.nodeMore.active = false
        cc.sys.localStorage.removeItem("HideAppTime")

        if (cc.winSize.width / cc.winSize.height > 2) {
            this.wgtGameTypes.left = Constant.BangLength
        }

        cc.director.on(Global.UserEvent.LoadingHallEnd, this.onLoadingHallEnd, this)
        cc.director.on(Global.UserEvent.PlayerLogin, this.onPlayerLogin, this)
        cc.director.on(Global.UserEvent.PlayerLogout, this.onPlayerLogout, this)
        cc.director.on(Global.UserEvent.PlayerPyChanged, this.onPlayerPyChanged, this)
        cc.director.on(Global.UserEvent.CloseThirdGame, this.onCloseThirdGame, this)
        cc.director.on(Global.UserEvent.CheckSignal, this.checkSignal.bind(this));
        cc.director.on(Global.UserEvent.AfterLogin, this.emitAfterLogin.bind(this));
        cc.director.on(Global.UserEvent.OpenBaoxiang, this.playBaoxiangAni.bind(this));
        cc.director.on(Global.UserEvent.UpdateShareRedPoint, this.updateShareRedPoint, this)
        cc.game.on(cc.game.EVENT_SHOW, this.onAppShow, this)
        cc.game.on(cc.game.EVENT_HIDE, this.onAppHide, this)
    }

    start() {
        this.refreshPlayerData()
        this.refreshOftenGames()
        this.requestPermissions()
        // 所有网络请求在获取到模版id之后请求
        this.getTemplateID()

    }

    onEnable() {
        this.aniHall.play();
        if (this._isGotTemplateId) {
            Player.isLogedIn() && this.pullUserData(false)
            this.pullNoticeData()
        }
        //if  (!CC_DEBUG){//浏览器先停止
            this.funcPing();
            this.schedule(this.funcPing.bind(this), this._interval);
        //}
        cc.log("===每次返回大厅，检测热更");
        cc.director.emit(Global.UserEvent.EnterHall)
    }

    onDisable() {
        cc.director.emit(Global.UserEvent.ExitHall)
        this.unschedule(this.funcPing)
    }

    update () {
        i18n.updateSceneRenderers()
    }

    onDestroy() {
        cc.director.off(Global.UserEvent.UpdateShareRedPoint, this.updateShareRedPoint, this)
        cc.director.off(Global.UserEvent.LoadingHallEnd, this.onLoadingHallEnd, this)
        cc.director.off(Global.UserEvent.PlayerLogin, this.onPlayerLogin, this)
        cc.director.off(Global.UserEvent.PlayerLogout, this.onPlayerLogout, this)
        cc.director.off(Global.UserEvent.PlayerPyChanged, this.onPlayerPyChanged, this)
        cc.director.off(Global.UserEvent.CloseThirdGame, this.onCloseThirdGame, this)
        cc.director.off(Global.UserEvent.CheckSignal, this.checkSignal.bind(this));
        cc.director.off(Global.UserEvent.AfterLogin, this.emitAfterLogin.bind(this));
        cc.director.off(Global.UserEvent.OpenBaoxiang, this.playBaoxiangAni.bind(this));
        cc.game.on(cc.game.EVENT_SHOW, this.onAppShow, this)
        cc.game.off(cc.game.EVENT_HIDE, this.onAppHide, this)
    }

    onBtnClick(event, userData) {
        if (userData === "register") {
            this.openChildUI(this.pfbRegisterUI)
        } else if (userData === "login") {
            this.openChildUI(this.pfbLoginUI)
        } else if (userData === "head") {
            this.openChildUI(this.pfbPlayerCenter, true)
        } else if (userData === "setting") {
            this.openChildUI(this.pfbSettingLayer)
        } else if (userData === "recharge") {

            this.openChildUI(this.pfbRechargeUI, true)
        } else if (userData === "customer") {
            this.openChildUI(this.pfbCustomerServiceUI)
        } else if (userData === "msgbox") {
            this.openChildUI(this.pfbMsgBoxUI, true)
        } else if (userData === "xima") {
            this.openChildUI(this.pfbXima, true)
        } else if (userData === "tuiguang") {
            let tuiguang = this.openChildUI(this.pfbTuiGuang, true);
            tuiguang && tuiguang.getComponent("TuiGuangLayer").updateUI();
        } else if (userData === "huodong") {
            let childUI = this.openChildUI(this.pfbActivity, false)
            childUI && childUI.getComponent("ActivityAndTask").updateUI(userData)
        } else if (userData === "renwu") {
            let childUI = this.openChildUI(this.pfbActivity, false)
            childUI && childUI.getComponent("ActivityAndTask").updateUI(userData)
        } else if (userData === "signal") {
            AudioManager.playSound("show")
            UIManager.showChangeDomainUI()
        } else if (userData === "tixian") {
            this.openChildUI(this.pfbWithdrawalUI, true)
        } else if (userData === "copy") {
            Utils.copyText(this.lbUserID.string);
            UIManager.showToastUI(i18n.t('HallUI.copy_succ'), Global.ToastType.OK)
        } else if (userData === "topDianzi") {
            let childUI = this.openChildUI(this.pfbTopElectronicLayer, true)
            childUI && (childUI.getComponent(TopElectronicUI).gameType = Global.GameType.Electronic)
        } else if (userData === "topQipai") {
            let childUI = this.openChildUI(this.pfbTopElectronicLayer, true)
            childUI && (childUI.getComponent(TopElectronicUI).gameType = Global.GameType.Chess)
        } else if (userData === "topBuyu") {
            let childUI = this.openChildUI(this.pfbTopElectronicLayer, true)
            childUI && (childUI.getComponent(TopElectronicUI).gameType = Global.GameType.Fish)
        } else if (userData === "more") {
            this.nodeMore.active = !this.nodeMore.active
        } else if (userData === "signIn") {
            this.nodeMore.active = false;
            let childUI = this.openChildUI(this.pfbActivity, true)
            childUI && childUI.getComponent("ActivityAndTask").updateUI(userData)
            // let sign = this.openChildUI(this.pfbSignInUI,true);
            // // let signIn :SignIn = sign.getComponent("SignIn");
            // // signIn.updateUI(null)

        } else if (userData === "rank") {
            // this.openChildUI(this.pfbRankingListUI)
            // this.nodeMore.active = false
            UIManager.showToastUI(i18n.t('HallUI.moment_open'), Global.ToastType.Warnning)
            this._clickTestBtnTimes++
            if (this._clickTestBtnTimes === 1) {
                this.scheduleOnce(function () {
                    this._clickTestBtnTimes = 0
                }, 2)
            }else if (this._clickTestBtnTimes > 6) {
                SDKManager.getShareTraceParm(function (data) {
                    UIManager.showTipUI(JSON.stringify(data))
                }.bind(this))
            }
        } else if (userData === "notice") {
            if (NoticeData.getPopUpItems().length > 0) {
                let childUI = this.openChildUI(this.pfbActivity, false)
                childUI && childUI.getComponent("ActivityAndTask").updateUI(userData)
                //this.openChildUI(this.pfbNoticeUI)
            } else {
                UIManager.showToastUI(i18n.t('HallUI.no_announcement') + "！", Global.ToastType.Warnning);
            }
            this.nodeMore.active = false
        } else if (userData === "down") {
            this.svGameTypes.scrollToBottom(1)
        } else if (userData === "oftenGame") {
            this.checkLoginAndShowUI()
        } else if (userData === "url") {
            Utils.copyText(this._siteUrl)
            UIManager.showToastUI(i18n.t('HallUI.copy_succ'), Global.ToastType.OK)
        } else if (userData === "fix") {
            this.openChildUI(this.pfbFixToolUI)
        } else {
            UIManager.showToastUI(i18n.t('HallUI.moment_open'), Global.ToastType.Warnning)
        }
    }

    async updateShareRedPoint() {
        let bShare = false;
        if  (Player.isLogedIn() && Player.getPy("currencySymbol") === "¥"
            && cc.sys.localStorage.getItem("CurrentLanguage") === "zh_CN"){
            bShare = true;
        }
        if  (!bShare) return ;
        let storageCopy = cc.sys.localStorage.getItem(Global.localStorageId.TaskCopy + Player.getPy("userID"));
        let storageSave = cc.sys.localStorage.getItem(Global.localStorageId.TaskSave + Player.getPy("userID"));
        let storageShare = cc.sys.localStorage.getItem(Global.localStorageId.TaskShare + Player.getPy("userID"));
        let storageSubmit = cc.sys.localStorage.getItem(Global.localStorageId.TaskSubmit + Player.getPy("userID"));
        let date = new Date();
        let shareRedPoint = 0;
        let userid = Player.getPy("userID")
        cc.log("===userId:", userid);
        if (!storageCopy || storageCopy != "copy" + Player.getPy("userID") ||
            !storageSave || storageSave != "save" + Player.getPy("userID") ||
            !storageShare || storageShare != "share" + Player.getPy("userID") ||
            !storageSubmit || storageSubmit !== date.getUTCDate().toString() + Player.getPy("userID")
        ) {
            shareRedPoint = 1;
        }
        NetworkLogic.taskGetTypes({}, function (listType) {
            cc.log("===taskGetTypes:", listType);
            let redPointNum = 0;
            for (let i = 0; i < listType.length; i++) {
                redPointNum += listType[i].finishCount
            }
            redPointNum += shareRedPoint;
            if (redPointNum > 0) {
                this.taskRedPoint.active = true;
            } else {
                this.taskRedPoint.active = false;
            }
        }.bind(this), function () {
            cc.log("===获取taskGetTypes类型错误:");
        })

    }


    private requestPermissions() {
        // 安卓申请权限
        if (cc.sys.os === cc.sys.OS_ANDROID) {
            let permissions = [
                "android.permission.READ_EXTERNAL_STORAGE",
                "android.permission.WRITE_EXTERNAL_STORAGE",
                "android.permission.CAMERA"
            ];
            Utils.requestPermissions(permissions)
        }
    }

    // 从服务器获取模版id
    private getTemplateID() {
        UIManager.showLoadingUI()
        NetworkLogic.getTemplates([Constant.PackageFlag], function (data) {
            UIManager.hideLoadingUI()
            for (let i = 0; i < data.length; i++) {
                const cfg = data[i]
                if (cfg.packageFlag === Constant.PackageFlag) {
                    this._isGotTemplateId = true
                    // 设置模版id
                    cc.sys.localStorage.setItem("TemplateID", cfg.templateId)
                    // 获取到模版id后，再开始请求数据
                    this.startNetworkRequest()
                    return
                }
            }
            UIManager.showTipUI(i18n.t('HallUI.tmpled_err'), function () {
                cc.game.end()
            }.bind(this))
        }.bind(this), function (response) {
            !response && UIManager.showChangeDomainUI(function () {
                this.getTemplateID()
            }.bind(this))
        }.bind(this))
    }

    async startNetworkRequest() {
        this.autoLogin()
        this.recordLogin()
        this.pullGameList()
        this.checkNativeVersion()
        this.initHomeLogo()
        await this.pullNoticeData()
        await this.sequenceWindow();
        this.updateShareRedPoint()
        cc.director.emit(Global.UserEvent.HallLoaded)
        await Utils.getInstallParms(this);
    }

    async funcPing() {
        this.signalNum.node.active = false;
        let num = await PingTool.checkHttpLatency(AddressManager.getServerDomain())
        let param = PingTool.getColorByNum(num)
        let color = param[0] as cc.Color
        let index = param[2] as number

        //this.signalNum.string = num.toString() + "ms"
        //this.signalNum.node.color = color；
        let type = cc.sys.getNetworkType();

        if (type === 1) {//wifis
            this.signalSprite.spriteFrame = this.wifiIconArr[index]
        } else {
            this.signalSprite.spriteFrame = this.signalIconArr[index]

        }
    }

    //播放开宝箱动画
    playBaoxiangAni(money, callbackClose) {
        let baoxiang = this.openChildUI(this.baoxiangPrefab);

        baoxiang.getComponent("ReceiveAwardAni").updateMoney(money);
        callbackClose && (baoxiang.getComponent("ReceiveAwardAni").callbackClose = callbackClose);
    }

    onGameItemClick(event, userData) {
        this.enterGame(event.target.gameConfig)
    }

    async enterGame(gameConfig) {
        if (!this.checkLoginAndShowUI()) {
            return
        }

        // 需要补全资料
        if (Player.getPy("visitorFillInfoTime").indexOf("2") !== -1 && Player.getPy("userType") === 2) {
            // 打开界面
            let hallUI = cc.find("Canvas/gameNode").getComponent("HallUI");
            hallUI.openChildUI(hallUI.pfbLoginCompleteInformation);
            return
        }

        if (gameConfig.gameStatus && gameConfig.gameStatus !== "0") {
            UIManager.showToastUI(i18n.t('HallUI.game_maintain'), Global.ToastType.Warnning)
            return
        }

        if (parseInt(gameConfig.entranceFlag) === 0) {
            cc.log("==gameConfig:",gameConfig);
            let data = {
                gameListId : gameConfig.gameListId
            }
            UIManager.showLoadingUI();
            NetworkLogic.forwardGameVerify(data,function (data) {
                UIManager.hideLoadingUI();
                cc.log("===货币接口forwardGameVerify:",data);
                if (data.flag) {

                    UIManager.showRateTips(gameConfig,data, function () {
                        this.enterThirdGame(gameConfig);
                    }.bind(this));
                }else{
                    this.enterThirdGame(gameConfig);
                }
                //UIManager.showTipUI("货币接口forwardGameVerify:" + data)
            }.bind(this),function () {
                UIManager.hideLoadingUI();

            }.bind(this))

        } else {
            this._thirdGamesListUI = (this._thirdGamesListUI && this._thirdGamesListUI.node) ? this._thirdGamesListUI : cc.instantiate(this.pfbThirdGamesListUI).getComponent(ThirdGamesListUI)
            this._thirdGamesListUI.plateformID = parseInt(gameConfig.id)
            this._thirdGamesListUI.gameTypeID = parseInt(gameConfig.gameCategoryId)
            this._thirdGamesListUI.node.parent ? this._thirdGamesListUI.node.active = true : this._thirdGamesListUI.node.parent = this.node.parent
            this._curChildUI = this._thirdGamesListUI.node
        }
    }

    enterThirdGame(gameConfig){
        UIManager.showLoadingUI()
        NetworkLogic.enterThirdGame(gameConfig.id, gameConfig.gameListId, function (data) {
            this.checkOftenGames(gameConfig)
            UIManager.hideLoadingUI()

            let url = data
            let wvManager = cc.find("Canvas") && cc.find("Canvas").getComponent(WebViewManager)

            if (wvManager) {
                // SG平台的彩票游戏没有做刘海屏适配，所以这里特殊处理一下
                if (gameConfig.platformGameType === Global.GameType.Lottery && gameConfig.platform === "SG") {
                    wvManager.isFillNotch = false
                } else {
                    wvManager.isFillNotch = true
                }

                // 0自动 1横屏 2竖屏
                if (parseInt(gameConfig.screenLayout) === 2) {
                    Utils.setOrientation("V")
                } else if (parseInt(gameConfig.screenLayout) === 1) {
                    Utils.setOrientation("H")
                }else{
                    Utils.setOrientation("A")
                }


                this._thirdGamesListUI && (this._thirdGamesListUI.node.active = false)

                EnterSoundManager.playSound("enter_youxi")
                AudioManager.pauseMusic()
                wvManager.openThirdGame(url)
            }
        }.bind(this))
    }
    



    checkSignal() {
        cc.log("=====大厅重新检测信号");
        this.funcPing();
    }

    emitAfterLogin(){
        this.bAutoLogin = false;
    }

    //登录之后打开签到
    async afterLogin() {
        //this.updateShareRedPoint()//重新登录更新红点
        PopWindowManager.popWindowArr = [];
        PopWindowManager.popNum = 0;
        cc.log("=====进入afterLogin");
        await this.setSignActivityTaskPop()
        PopWindowManager.openNext();
    }

    async setSignActivityTaskPop() {
        if (!Constant.PopSwitch) return;//本地使用，提交时请修改为true；
        let bSignSwitch = await SignData.getSignSwitch();
        if (bSignSwitch) {//添加签到
            let bCanSign = await SignData.getCanSign();
            bCanSign && PopWindowManager.popWindowArr.push({ pfb: this.pfbSignInUI, data: null })
        }

        let recommendActivityData = await ActivityData.getRecommendActivity();
        if  (Array.isArray(recommendActivityData) && recommendActivityData.length > 0){
            for (let i = 0; i < recommendActivityData.length; i++) {//添加推荐活动
                PopWindowManager.popWindowArr.push(
                    {
                        pfb: this.pfbRecommondActivity,
                        data: recommendActivityData[i]
                    }
                );
            }
        }
        let taskMainSwitch = await TaskData.getTaskMainSwitch();
        if (taskMainSwitch) {//添加推荐活动
            let taskPopSwitch = await TaskData.getTaskPopSwitch();
            if (taskPopSwitch && Player.isLogedIn()) {
                let recommendData = await TaskData.getRecommendTask();
                if (recommendData.length > 0) {
                    for (let i = 0; i < recommendData.length; i++) {
                        PopWindowManager.popWindowArr.push({ pfb: this.pfbRecommondTask, data: recommendData[i] });
                    }
                }
            }
        }
    }

    async sequenceWindow() {
        if (!Constant.PopSwitch) return;
        if (!Player.isLogedIn()) {//未登录情况
            let bPopResister = cc.sys.localStorage.getItem("OpenRegister");
            let bPopQuickResister = cc.sys.localStorage.getItem("OpenLoginQuickRegister");
            if(bPopResister){
                PopWindowManager.popWindowArr.push({ pfb: this.pfbRegisterUI, data: null });
            }else if(bPopQuickResister){
                PopWindowManager.popWindowArr.push({ pfb: this.pfbLoginQuickRegister, data: null });
            }
            else if (NoticeData.getPopUpItems().length > 0) {
                PopWindowManager.popWindowArr.push({ pfb: this.pfbNoticeUI, data: null });
            }
        } else {//已登录情况
            if (JSON.stringify(Player.getPy("serverData")) === "{}") {//没有数据先等待数据拉取，防止为空
                await this.asyncPullUserData();
            }
            // if (false) {//不要微信功能了
            //     let wechatData = await WechatNoticeData.getWechatData();
            //     if (wechatData.bOpen)//开关开了才传
            //         PopWindowManager.popWindowArr.push({ pfb: this.pfbBindWeChat, data: wechatData });
            // }
            if (NoticeData.getPopUpItems().length > 0) {//公告
                PopWindowManager.popWindowArr.push({ pfb: this.pfbNoticeUI, data: null });
            }
            await this.setSignActivityTaskPop();
        }
    }

    async onLoadingHallEnd() {
        this._bEnterHall = true;
        cc.log("===进入loadingHallende this._bEnterHall：",this._bEnterHall);
        this.aniHall.play();

        EnterSoundManager.playSound("enter_app")
        await this.setBgMusic()
        await this.showVersionUI()
        await this.pullLoginConfig()
        let signSwitch = await SignData.getSignSwitch();
        if (!signSwitch) {
            this.signBtn.active = false;
        }
        //  打开数组的第一个窗口
        PopWindowManager.openNext();

    }

    onPlayerLogin(bPop) {
        this.pullUserData(bPop)
    }

    onPlayerLogout() {
        this.nodePlayerUnLogin.active = true
        this.nodePlayer.active = false
        this._isPulledLoginConfig = false;
        if (this._curChildUI) {
            this._curChildUI.destroy()
            Utils.showGameNode()
        }
        SignData.resetSignData();
        TaskData.resetData();
        cc.log("== hall onPlayerLogout重置任务数据");
        ActivityData.resetData();
        this.updateShareRedPoint();
    }

    onPlayerPyChanged(data) {
        this.refreshPlayerData()
    }

    onCloseThirdGame() {
        let bPauseMusic  = cc.sys.localStorage.getItem("pauseMusic");
        cc.log("====bPauseMusic:",bPauseMusic);
        if (bPauseMusic === "true" ) return;
        AudioManager.resumMusic()
    }

    onAppShow() {
        SDKManager.setBadge(0)
        // 一段时间内没有打开过app，则打开后重启app（为了拉取最新的游戏列表数据）
        let hideAppTime = parseInt(cc.sys.localStorage.getItem("HideAppTime") || "0")
        let curTime = new Date().getTime()
        if (hideAppTime !== 0 && curTime - hideAppTime > 6 * 60 * 60 * 1000) {
            Utils.restartGame()
        }
    }

    onAppHide() {
        cc.sys.localStorage.setItem("HideAppTime", new Date().getTime())
        cc.sys.garbageCollect()
    }

    isExistChildUI() {
        return this._curChildUI && this._curChildUI.isValid
    }

    public openChildUI(perfab: cc.Prefab, isCheckLogin?: boolean) {
        if (!isCheckLogin || this.checkLoginAndShowUI()) {
            AudioManager.playSound("show");
            this._curChildUI = cc.instantiate(perfab);
            this._curChildUI.parent = this.node.parent
            return this._curChildUI;
        }
    }

    public checkLoginAndShowUI() {
        if (!Player.isLogedIn()) {
            AudioManager.playSound("show")
            this._curChildUI = cc.instantiate(this.pfbLoginUI)
            this._curChildUI.parent = this.node.parent
            return false
        }

        return true
    }

    // private async refreshTaskNum() {
    //     let num = await TaskData.getUnCompleteTaskNum();
    //     if (num === 0){
    //         this.labTaskRedNum.node.parent.active = false;
    //     }else{
    //         this.labTaskRedNum.node.parent.active = true;
    //         this.labTaskRedNum.string = num.toString();
    //     }
    // }

    private refreshPlayerData() {
        this.lbUserID.string = Player.getPy("userFlag")
        this.lbVip.string = "VIP " + Player.getPy("vip")
        Player.getPy("head") && (this.rspHead.url = Player.getPy("head"))
        this.barExp.progress = Player.getPy("percentage") && (Player.getPy("percentage").percentage/100).toFixed(2);
        // if (Player.getPy("expNextVip") === 0) {
        //     this.barExp.progress = 0
        // } else {
        //     this.barExp.progress = Player.getPy("exp") / Player.getPy("expNextVip")
        // }
    }

    private recordLogin() {
        NetworkLogic.loginRecord()
    }

    private autoLogin() {
        this.bAutoLogin = true;
        Player.setPy("token", cc.sys.localStorage.getItem("Token") || "")
    }

    private pullGameList() {

        NetworkLogic.getGameList(null, function (data) {
            cc.log("===拉取列表getGameList",data);
            GameList.serverData = data
        }.bind(this), function (response) {
            !response && UIManager.showChangeDomainUI(function () {
                this.pullGameList()
            }.bind(this))
        }.bind(this))
    }

    private pullUserData(pop= true) {
        NetworkLogic.userInfo({ "loadMoney": true }, async function (data) {
            Player.setPy("serverData", data);
            cc.log("===pullUserData userInfo:",data);
            if (pop  && !this.bAutoLogin){
                this.bAutoLogin = false;
                await this.afterLogin();
            }

            //if (this._bEnterHall){
                await this.pullLoginConfig()
            //}
            SDKManager.setAlias(Player.getPy("userID"))
            this.nodePlayerUnLogin.active = false
            this.nodePlayer.active = true
            this.pullMailCount()
            this.updateShareRedPoint();
        }.bind(this), function (response) {
            if (!response) return
            Player.logout()
        }.bind(this))
    }

    asyncPullUserData(): Promise<any> {
        return new Promise<any>(resolve => {
            NetworkLogic.userInfo({ "loadMoney": true }, function (data) {
                Player.setPy("serverData", data)
                resolve(true);
            }.bind(this), function (response) {
                resolve(false);
            }.bind(this))
        })

    }

    private pullMailCount() {
        NetworkLogic.receiveMessageCount(function (data) {
            this.nodeTimeReceive.active = data.money > 0
            this.lbUnReadMsg.node.parent.active = data.count > 0
            if (data.count > 0) {
                this.lbUnReadMsg.string = Math.min(data.count, 99)
            }
        }.bind(this))
    }

    private pullNoticeData(): Promise<any> {
        return new Promise(resolve => {
            NetworkLogic.noticeList(function (data) {
                cc.log("====notice data:", data);
                NoticeData.setData(data)
                this.createNoticeBanner()
                resolve(0);
            }.bind(this), function () {
                resolve(0);
            })
        })

    }

    private pullLoginConfig():Promise<void> {
        return new Promise(resolve => {
            if (!Player.isLogedIn() || !Player.isVisitor()) {
                resolve()
            } else {
                UIManager.showLoadingUI()
                NetworkLogic.userLoginConfig({},function (data) {
                    UIManager.hideLoadingUI()
                    cc.log("===获取visitorFillInfoTime：", data);
                    Player.setPy("visitorFillInfoTime", data.visitorDataPerfectTime)
    
                    //cc.log("===用户类型userType：", Player.getPy("userType"));
                    // // 需要补全资料,现在登陆时不补全资料
                    // if (!this._isPulledLoginConfig && Player.getPy("visitorFillInfoTime").indexOf("1") !== -1 && Player.getPy("userType") === 2) {
                    //     // 打开界面
                    //     let hallUI = cc.find("Canvas/gameNode").getComponent("HallUI");
                    //     hallUI.openChildUI(hallUI.pfbLoginCompleteInformation);
                    // }
                    // this._isPulledLoginConfig = true
                    resolve()
                }.bind(this), function () {
                    resolve()
                }.bind(this))
            }
        })
    }



    private checkOftenGames(gameConfig) {
        if (parseInt(gameConfig.entranceFlag) !== 0) {
            return
        }

        let cacheGames = JSON.parse(cc.sys.localStorage.getItem("OftenGames") || "[]")
        let found = false

        for (let i = 0; i < cacheGames.length; i++) {
            const element = cacheGames[i];
            if (element.gameConfig.id === gameConfig.id) {
                found = true
                element.date = new Date().getTime()
                break
            }
        }

        if (!found) {
            cacheGames.push({ gameConfig: gameConfig, date: new Date().getTime() })
            cc.director.emit(Global.UserEvent.AddOftenGameConfig, gameConfig)
        }

        cc.sys.localStorage.setItem("OftenGames", JSON.stringify(cacheGames))
    }

    private refreshOftenGames() {
        let cacheGames = JSON.parse(cc.sys.localStorage.getItem("OftenGames") || "[]")

        for (let i = 0; i < cacheGames.length; i++) {
            const element = cacheGames[i];
            // 15天过期
            if (new Date().getTime() - element.date > 15 * 24 * 60 * 60 * 1000) {
                cacheGames.splice(i, 1)
                i--
            }
        }

        cc.sys.localStorage.setItem("OftenGames", JSON.stringify(cacheGames))
    }

    //滚动公告
    private createNoticeBanner() {
        let banners = NoticeData.getBannerItems()
        let content = ""

        banners.forEach(cfg => {
            content += "    " + cfg.content
        });

        content = content.replace(/[\r\n]/g, "")

        if (content !== this.lbNotice.string) {
            this.lbNotice.node.active = true
            this.lbNotice.string = content
            this.lbNotice.node.stopAllActions()
            this.lbNotice.node.x = this.lbNotice.node.parent.width
            this.scheduleOnce(function () {
                let time = (this.lbNotice.node.width + this.lbNotice.node.parent.width) / (this.lbNotice.node.parent.width / 15)
                this.lbNotice.node.runAction(cc.repeatForever(cc.sequence(cc.moveTo(time, cc.v2(-this.lbNotice.node.width, 0)), cc.callFunc(function () {
                    this.lbNotice.node.x = this.lbNotice.node.parent.width
                }.bind(this)))))
            }, 0.1)
        }
    }

    private async setBgMusic() {
        // // 设置背景音乐
        // let musicName = cc.sys.localStorage.getItem("MusicName")
        //
        // if (!musicName) {
        //     musicName = "bg.mp3"
        //     cc.sys.localStorage.setItem("MusicName", musicName)
        // }
        cc.log("===进入setBgMusic");
        await AudioManager.startPlayHallMusic()
    }

    private checkNativeVersion() {
        let nativeVersion = ""
        let nums = Utils.getNativeVersion().split(".")

        // 因为服务器要求版本号为三位，所以这里特殊处理一下
        for (let i = 0; i < 3; i++) {
            const num = nums[i];
            if (num) {
                nativeVersion += (nativeVersion ? ("." + num) : num)
            } else {
                nativeVersion += (nativeVersion ? ".0" : "0")
            }
        }
        let resVersion = cc.sys.localStorage.getItem("CurrentVersion") || '0.0.0';
        resVersion = resVersion.slice(0, resVersion.lastIndexOf("."));
        cc.log("====resVersion:",resVersion);
        NetworkLogic.getHotUpdateInfo({
            devieceType: cc.sys.os,
            // packageName: Utils.getPackageName(),
            packageName: Constant.UpdatePackageName,
            // versionCode: "v" + nativeVersion
            versionCode: "v" + resVersion
        }, function (data) {
            this._versionData = data
            cc.log("===this.versionData:",JSON.stringify(data));
        }.bind(this))
    }

    private showVersionUI(): Promise<any> {
        return new Promise(resolve => {
            if (this._versionData) {
                let isForceUpdate = parseInt(this._versionData.isForceUpdate) === 1

                if (isForceUpdate) {
                    UIManager.showTipUI(this._versionData.info.replace(",", "\n"), function () {
                        cc.sys.openURL(this._versionData.downloadUrl)
                        cc.game.end()

                    }.bind(this), i18n.t('baes_text.update'))
                } else {
                    UIManager.showConfirmUI(this._versionData.info.replace(",", "\n"), function () {
                        cc.sys.openURL(this._versionData.downloadUrl)
                        resolve(1)
                    }.bind(this), i18n.t('baes_text.update'), function () {
                        resolve(0)
                    }.bind(this), i18n.t('baes_text.cancel'))
                }
            } else {
                resolve(0)
            }
        })
    }

    private initHomeLogo () {
        NetworkLogic.siteGlobal(function (data) {

            let siteLogo = Array.isArray(data.siteLogo) && data.siteLogo[0];
            if  (!siteLogo) {
                this.remoteLogo.node.active = false;
                return;
            }
            this._siteUrl = siteLogo.siteUrl;
            this.remoteLogo.url = siteLogo.siteLogoUrl;
        }.bind(this), function () {

        }.bind(this))
    }
}
